import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import jwtDecode from 'jwt-decode';

/**
 * A simple component to display the current access token's
 * expiration time for testing purposes.
 */
const TokenTestDisplay = () => {
  const { token } = useAuth();
  const [expiresIn, setExpiresIn] = useState(0);

  useEffect(() => {
    if (!token) {
      setExpiresIn(0);
      return;
    }

    const calculateExpiry = () => {
      try {
        const decoded = jwtDecode(token);
        const expirationTime = decoded.exp * 1000;
        const currentTime = Date.now();
        const timeLeft = Math.round((expirationTime - currentTime) / 1000);
        setExpiresIn(timeLeft > 0 ? timeLeft : 0);
      } catch (error) {
        setExpiresIn(0);
      }
    };

    calculateExpiry(); // Calculate immediately on token change
    const interval = setInterval(calculateExpiry, 1000); // Update every second

    return () => clearInterval(interval);
  }, [token]);

  if (!token) {
    return (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-md my-4 shadow-lg">
            <strong>Status:</strong> Not Logged In
        </div>
    );
  }

  return (
    <div className="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded-md my-4 shadow-lg">
      <strong>Token Status:</strong> Access token expires in <strong>{expiresIn}</strong> seconds.
      <p className="text-sm mt-1">
        (A refresh is scheduled to occur about 5 minutes before expiration. With a 90s test token, it should refresh almost immediately).
      </p>
    </div>
  );
};

export default TokenTestDisplay;
